import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-games',
  templateUrl: './games.component.html',
  styleUrls: ['./games.component.scss']
})
export class GamesComponent implements OnInit {

  @Input('interaction') interaction;
  alertColor;
  public localStorage = localStorage;

  constructor() { }

  ngOnInit(): void {
  }

  flash(status) {
    this.alertColor = status;
    setTimeout( () => {
      this.alertColor = null;
    }, 2000);
  }


}
